import { useState } from "react";

import useResizeObserver from "./useResizeObserver";

/**
 * Return true when the width of the element is wider than the passed in value.
 * @param {import("react").RefObject} ref
 * @param {number} param1.px
 * @param {any} param1.refreshTrigger - if this changes, the ref will be sent through the observer again.
 * @returns {boolean}
 */
const useIsWiderThan = (ref, { px = 719, refreshTrigger } = {}) => {
  const [isWiderThan, setIsWiderThan] = useState(ref.current?.clientWidth > px);
  const [hasInitialized, setHasInitialized] = useState(false);

  // Using 17px to force double the width of a scrollbar of margin to trigger the change.
  useResizeObserver(
    ref,
    () => {
      setTimeout(() => {
        if (ref.current?.clientWidth - 17 > px) {
          setIsWiderThan(true);
        } else if (ref.current?.clientWidth + 17 < px) {
          setIsWiderThan(false);
        }
        setHasInitialized(true);
      });
    },
    refreshTrigger
  );
  return hasInitialized ? isWiderThan : ref.current?.clientWidth > px;
};

export default useIsWiderThan;
